<template>
    <div>


        <div class="page_ai_container">
            <div class="ai_container">
                <div class="ai_headline">
                    <headlineVue></headlineVue>
                </div>

            </div>
            <div class="ai_character_container">
                <div class="ai_character">
                    <characterVue></characterVue>
                </div>
            </div>

            <div class="ai_around_list">
                <aroundListNew></aroundListNew>
            </div>
            <div class="ai_percent_container">
                <div class="ai_percent">
                    <percentVue></percentVue>
                </div>
            </div>
        </div>

        <!-- <div class="ai_feed ss">
            <feedVue></feedVue>

            <img src="../../assets/images/ai/icon_d.png" alt="" class="feed_icon_d">
        </div> -->
    </div>
</template>

<script>
import { pageContentList } from "./data";
import headlineVue from "./headline.vue";
import characterVue from "./character.vue";
import percentVue from "./percent.vue";
import feedVue from "./feed.vue";
import aroundListNew from "./aroundListNew.vue";
import CustomerList from "@/components/customerList/index.vue"
export default {
    components: {
        headlineVue,
        characterVue,
        percentVue,
        feedVue,
        aroundListNew,
        CustomerList
    },
    data() {
        return {
            pageContentList
        }
    }
}
</script>

<style lang='scss'>
@import "../../assets/css/minix.scss";

.page_ai_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // background: linear-gradient(rgb(237 237 237 / 40%), rgb(255 255 255 / 50%)),
    //     linear-gradient(hsl(0deg 0% 100% / 50%), hsl(0deg 0% 100% / 50%)),
    //     url(/img/ai_conbj.f4e7f516.png) no-repeat;
    // background-size: contain;
    // background-repeat: no-repeat;
    background-color: #F6FAFC;

    .ai_container {
        @include responsive-width(1200px);

        .ai_headline,
        .ai_around_list,
        .ai_percent,
        .ai_case {
            display: flex;
            justify-content: center;
            margin: 40px 0;
        }
    }
}

.ai_character_container {
    width: 80%;
    margin: 0 auto;
    padding: 120px 0 220px 0;
    background-image: url('../../assets/images/ai/ai_bg1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.ai_around_list {
    margin-top: -160px;
    @include responsive-width(1200px);
}

.ai_character {
    @include responsive-width(1200px);
    margin: 0 auto;
}

.ai_headline {
    padding: 60px 0;
    background-color: #fff;
}

.ai_feed {
    position: relative;

    .feed_icon_d {
        position: absolute;
        top: -44px;
        right: 20%;
    }
}

.ai_percent_container {
    width: 100%;
    margin-top: 20px;
    padding: 40px 0;
    background-image: url('../../assets/images/ai/ai_percent_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.ai_percent {
    @include responsive-width(1200px);
    margin: 0 auto;
}

.ai_case {
    margin: 20px 0 10px 0;

    .customer_comment_title {
        font-size: 26px;
        font-weight: bold;
        color: #393939;
        margin: 30px;
        text-align: center;
    }
}

@media screen and (max-width: 768px) {
    .ai_character_container {
        width: 100%;
        background-size: contain;
    }

    .ai_around_list {
        padding: 0;
    }

    .ai_container {

        .ai_headline,
        .ai_character,
        .ai_percent,
        .ai_case {
            margin: 50px 0 !important;
        }
    }

    .ai_feed {
        position: relative;

        .feed_icon_d {
            width: 50px;
            top: -5%;
            right: 7%;
        }
    }
}
</style>